import { Injectable } from '@angular/core';
import { CrudService } from '@appstrax/services/database';
import { MarketplaceBid } from '@models';

@Injectable({ providedIn: 'root' })
export class MarketplaceBidService extends CrudService<MarketplaceBid> {
  constructor() {
    super('marketplace-bids', MarketplaceBid);
  }
}

